import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadAspectRatioCardImage } from '../Carousel/CarouselCard';
import { FormattedMessage } from '../Intl';
import { TallCarouselCard, AspectRatioCardTitle, AspectRatioCardText } from '../Carousel/CarouselCard';
import { getSubtitle } from './utils';

import './PropertyTypeCard.less';

const PropertyTypeCard = ({
  clickUrl,
  propertyTypeKey,
  formattedCount,
  imageUri,
  subtitleTemplate,
  onClick
}) => (
  <FormattedMessage id={propertyTypeKey}>
    {propertyTypePlural => (
      <TallCarouselCard
        clickUrl={clickUrl}
        className="PropertyTypeCard"
        onClick={onClick}
      >
        <LazyLoadAspectRatioCardImage
          data-slot="figure"
          imageUri={imageUri}
        />
        <AspectRatioCardTitle data-slot="caption" title={propertyTypePlural} />
        <AspectRatioCardText data-slot="content" text={getSubtitle(subtitleTemplate, formattedCount, propertyTypePlural)} />
      </TallCarouselCard>
    )
    }
  </FormattedMessage>
);

PropertyTypeCard.propTypes = {
  clickUrl: PropTypes.string.isRequired,
  propertyTypeKey: PropTypes.string.isRequired,
  formattedCount: PropTypes.string.isRequired,
  imageUri: PropTypes.string.isRequired,
  subtitleTemplate: PropTypes.string.isRequired
};

export default PropertyTypeCard;
